// Select the .wp-block-zp4-masthead if exists
let masthead = document.querySelector('.wp-block-zp4-masthead');
// Check if the masthead exists
if (masthead) {
    console.log(masthead);

    // Select all empty tags inside the masthead element
    const emptyTags = masthead.querySelectorAll('.wp-block-zp4-masthead .content-container *');

    // Loop through each element
    emptyTags.forEach((tag) => {
        // Check if the element's text content is empty
        if (tag.textContent.trim() === '') {
            // Remove the empty element
            tag.remove();
        }
    });
}